// extracted by mini-css-extract-plugin
export default {"wrapper":"AccreditationA_wrapper__-wZyQ"};